import { stateName } from './constants'
import { AllState } from './types'

const localState = (state: AllState) => state[stateName]

export const getBanners = (state: AllState) => localState(state).banners
export const getBannersUiState = (state: AllState) => localState(state).uiState
